import { Component, OnInit } from '@angular/core';
import { BrowseobligorService } from '../services/browseobligor.service';
import { Browseobligor } from '../Models/browseobligor';
import { Router } from '@angular/router';
import { IssuerAPIService } from '../services/issuer-api.service';
declare function responsiveVoiceSpeak(title, innerText): any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare var $: any;
declare function browseobligorvoiceOnKeyPress(value, key, targetid): any;
declare function voiceForObligorCount(obligorCount): any;
declare function voiceForLastObligor(targetid): any;
declare const voiceForObligorNoFound: any;
declare const voiceForObligorSearch: any;
declare function FontSizeSettings(): any;
var IsLoadFontSizeSettings = 0;

@Component({
  selector: 'app-reviewtoolkit',
  templateUrl: './reviewtoolkit.component.html',
  styleUrls: ['./reviewtoolkit.component.css']
})

export class ReviewtoolkitComponent implements OnInit {
  routeName: string;
  CountRows: number = 0;
  lblResultTable; string;
  public allBrowseobligor: any = null;
  public isFullAccess: Boolean
  constructor(private browseobligorService: IssuerAPIService, private router: Router) { }
  onkeypress(event, obligorId, obligorDesc, webcastsPresent) {
    debugger;
    // Enable/Disable search button on the Obligor Name Search Box (3 or more letters).
    if (event.target.id == "inputSuccess5") {
      var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      if ((event.target.value.length + event.key.length) == 3 || (event.target.value.length + event.key.length) > 3) {
        btnSearch.disabled = false;
      }
      else {
        btnSearch.disabled = true;
      }
    }

    if (event.keyCode == 27) {
      //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorName" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      //}
      return;
    }

    //Set value for obligorId and obligorDesc for all components.
    if (event.target.id == "inputSuccess5") {
      if (event.keyCode != 17 && event.keyCode != 0) {
        browseobligorvoiceOnKeyPress(event.target.value, event.key, event.target.id);
      }
    }
    else if (event.target.id == "tdwebcasts" && event.keyCode == 13) {
      localStorage.clear();
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      if (webcastsPresent == true) {
        //this.router.navigate(['/Accessingwebcasts']);
      }
      else {
        BrowseObligorsponsiveVoiceSpeak("", "", 39, false, "tdwebcasts", "", false, "", "", "");
      }
    }
    else if (event.target.id == "tdOverview" && event.keyCode == 13) {
      //localStorage.clear();
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      //this.router.navigate(['/investor-browse-borrowing-documents']);
    }
    else if (event.target.id == "tdHistory" && event.keyCode == 13) {
      //localStorage.clear();
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      //this.router.navigate(['/investor-browse-filing-types']);
    }
    else if (event.target.id == "tdQA" && event.keyCode == 13) {
      localStorage.clear();
      localStorage.OBLIGOR_ID = obligorId;
      localStorage.OBLIGOR_DESC = obligorDesc;
      //this.router.navigate(['/ask-aquestion']);
    }
    else if (event.keyCode == 32) {
      if (event.target.id == "btnClear" || event.target.id == "btnSearch") {
        event.preventDefault();
        return;
      }
    }
  };
  onKeyUp(event: any, obligorId, obligorDesc) {
    debugger;

    $('#hdlastRow').val('0');

    // check no data in table
    if (event.target.title == "noData" && event.keyCode == 9) {
      var innertext = "No data available!";
      responsiveVoiceSpeak("", innertext + ". Use escape key to exit the table and go to footer.");
      return;
    }

    if ((event.target.id == "tdobligorName" || event.target.id == "tdobligorState") && event.keyCode == 16) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("reviewtoolkit").innerText, "reviewtoolkit", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("reviewtoolkit").focus();
      return;
    }

    if (event.target.id == "reviewtoolkit" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("reviewtoolkit").innerText, "reviewtoolkit", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("reviewtoolkit").focus();
      return;
    }

    if (event.target.id == "tblSelectObligor" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tblSelectObligor").innerText, "tblSelectObligor", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("tblSelectObligor").focus();
      return;
    }

    if (event.target.id == "tblobligorList" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tblobligorList").innerText, "tblobligorList", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("tblobligorList").focus();
      return;
    }
      
    if (event.keyCode != 17) {

      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        this.UpArrowKey(event);
        return;
      }
      else if (event.keyCode == 40) {
        debugger;
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        this.DownArrowKey(event, child_cell);
        return;
      }
      else if (event.keyCode == 39) {
        debugger;
        var child_cell = $(event.target).index();
        this.RightArrowKey(event, child_cell);
        return;

      }
      else if (event.keyCode == 37) {
        var child_cell = $(event.target).index();
        this.LeftArrowKey(event, child_cell)
        return;
      }
      else if (event.keyCode == 27) {
        //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorName" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        //}
      }
      
      else if (event.keyCode == 13 && event.target.id == "tdobligorName")//=========Enter 
      {
        this.onStore_ObligorId(event, obligorId)
        
      }
      else if (event.keyCode == 16)//=============Shift + Tab Go
      {
        if (event.target.id == "tdobligorName" || event.target.id == "tdwebcasts" || event.target.id == "tdAlerts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
          document.getElementById("inputSuccess5").focus();
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("inputSuccess5").innerText, document.getElementById("inputSuccess5").id, event.target.type, document.getElementById("inputSuccess5").title, event.target.htmlFor, event.target.alt, event.key);
        }
      }

      else if (event.keyCode == 9) {
        if (event.target.id == "tdobligorName") {
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        else {
          if (event.keyCode == 9) {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
          }
        }
      }
      else {
        if (event.keyCode == 9) {
          if (event.target.id == "liID") {
            document.getElementById("AID").focus();
            document.getElementById("AID").tabIndex = event.target.tabIndex;
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("AID").innerText, document.getElementById("AID").id, event.target.type, document.getElementById("AID").title, event.target.htmlFor, event.target.alt, event.key);
          }
        }
        else {
          //if (event.keyCode == 9) {
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
          //}
        }
      }
    }
  };
  DownArrowKey(event: any, child_cell: string) {
    debugger;
    var innerText, title;
    if (event.target.id == "tdobligorName") {

      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;


        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }

    else if (event.target.id == "tdobligorState") {
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {
        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
    }

  }
  UpArrowKey(event: any) {
    debugger;
    var child_cell = $(event.target).index(), innerText,title;
    if (event.target.id == "tdobligorName") {
       innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
       title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }

    if (event.target.id == "tdobligorState") {
       innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
       title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    
  }
  LeftArrowKey(event: any, child_cell: string) {
    debugger;
    if (event.target.id == "tdobligorState") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdobligorName") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdobligorName") {
      var target = $(event.target).next();
     
      if (target[0].id == "tdobligorState") {
        $(event.target).parent().prev().children("td").eq(1).focus();
        $('#hdlastRow').val('0');
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

        
      }
    }
  }
  RightArrowKey(event: any, child_cell: string) {
    debugger;
    if (event.target.id == "tdobligorName") {
      debugger;
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdobligorState") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }


        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
     }
    }

    if (event.target.id == "tdobligorState") {
      var obligorDescIndex = 0;
      $(event.target).parent().next().children("td").eq(obligorDescIndex).focus();
      if (event.target.id == "tdobligorState") {
        if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;

          if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
            $('#hdlastRow').val('1');
          }
          else {
            $('#hdlastRow').val('0');
          }
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdobligorName", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }


  }
  ngOnInit() {
    debugger;
   
    //document.getElementById("BrowseObligorPage").style.display = "none";
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      $('#btnPlayPause').css('display', 'block');
    }

    responsiveVoiceSpeak("", "This is Select obligor page. Use tab to go to the next field.");
    
    this.loadBrowseObligors_ToolKitAccess();
    this.MagnifieronDynamicChecking();
  }
  setFontSizeSettings() {
    if (IsLoadFontSizeSettings == 1) {
      FontSizeSettings();
      IsLoadFontSizeSettings = 0;
    }
  }
    /*
   * to get full access browser obligorIds
   */
  loadBrowseObligors_ToolKitAccess() {
    debugger;
    document.getElementById("overlay").style.display = "block";
    this.browseobligorService.GetIssuerBrowseObligors_ReviewToolKit(true).subscribe(data => {
      document.getElementById("overlay").style.display = "none";
       debugger;
       this.CountRows = data['length'];
       this.lblResultTable=data['length']
        if (data['length'] == 0) {
          //voiceForObligorNoFound();
        }
        if (data['length'] == 1) {
          debugger;
          this.allBrowseobligor = data;

          localStorage.setItem("OBLIGOR_ID", this.allBrowseobligor[0].obligorId);
          //voiceForObligorCount(data['length']);
          IsLoadFontSizeSettings = 1;

          if (localStorage.getItem("Page_Navigation")) {
            var page_navigate = localStorage.getItem("Page_Navigation");
            if (page_navigate == "CR") {
              this.router.navigate(['/compliance-review']);
            }
            else if (page_navigate == "AD") {
              this.router.navigate(['/archivedcurrentdocuments']);
            }

            else
              this.router.navigate(['/mydac']);
          }

        }

        if (data['length'] > 1) {
          debugger;
          this.allBrowseobligor = data;
          //voiceForObligorCount(data['length']);
          IsLoadFontSizeSettings = 1;
         

        }

      });
    
  }
  onStore_ObligorId(event: any, obligorId: string) {
    debugger;
    localStorage.setItem("OBLIGOR_ID", obligorId);

    if (localStorage.getItem("Page_Navigation")) {
      var page_navigate = localStorage.getItem("Page_Navigation");
      if (page_navigate == "CR") {
        this.router.navigate(['/compliance-review']);
      }
      else if (page_navigate == "AD") {
        this.router.navigate(['/archivedcurrentdocuments']);
      }

      else if (page_navigate == "MD") {
        this.router.navigate(['/mydac']);
      }
      else if (page_navigate == "CA") {
        this.router.navigate(['/continuingeducation']);
      }  
      else if (page_navigate == "BO") {
        this.router.navigate(['/browse-obligor']);
      }  
      else {
        this.router.navigate(['/mydac']);
      }
    }
    else {
      this.router.navigate(['/mydac']);
    }

    
   
  }
  MagnifieronDynamicChecking() {
    FontSizeSettings();
  }
}
